export const navbarStyles = {
  appBar: {
    background: "#FFFFFF",
    boxShadow: "none",
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    paddingRight: "18px",
  },
  notification: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
    alignItems: "center",
    marginLeft: "auto",
    gap: "7px",
  },
  pageTitle: {
    fontWeight: "500",
    fontSize: "17px",
    lineHeight: "22px",
    color: "#103B66",
    textTransform: "capitalize",
  },
  //   icons: {
  //     color: "rgba(255, 255, 255, 0.7)!important",
  //     marginLeft: "20px",
  //   },
  text: {
    fontFamily: "Source Sans Pro",
    fontWeight: 400,
    fontSize: "15px",
    lineHeight: "20px",
    color: "#103B66",
  },
};
